import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'
import Media from 'components/common/Media'
import { getOnClickAndOnKeyPressDownEvents } from 'helpers/getOnClickAndOnKeyPressDownEvents'

const TopStoreSelector = ({ handleStoreLocationClick }) =>
  <Wrapper>
    <Text>
      In order to proceed with requesting an appointment please find a Big O Tires location near you.
    </Text>
    <StyledButton full quotePage { ...getOnClickAndOnKeyPressDownEvents(handleStoreLocationClick) }>
      Select Location
    </StyledButton>
  </Wrapper>

export default TopStoreSelector

TopStoreSelector.propTypes = {
  handleStoreLocationClick: PropTypes.func
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  margin: 20px 16px;
`

const Text = styled.span`
  text-align: center;
  display: block;
`

const StyledButton = styled(Button)`
  margin-top: 25px;
  margin-bottom: 20px;
  padding: 14px 30px 15px;
  font-size: 16px;
  ${Media.desktop`
    width: 340px;
  `}
`
